export const selectRainbowData = (state) => state.rainbow.getIn(['data', 'rainbow'])
